import { Sentinel } from '@studiometa/ui';

export interface FooterProps extends Sentinel {
  $el: HTMLElement;
}

export default class Footer extends Sentinel {
  static config = {
    name: 'Footer',
  };

  onIntersected({ args: [entries] }: { args: [IntersectionObserverEntry[]] }) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        this.$el.classList.add('is-visible');
      } else {
        this.$el.classList.remove('is-visible');
      }
    }
  }
}
